export default function NoPageFounf() {
  return (
    <div className="centered">
      <p>Page not found!</p>
    </div>
  );
}
